__turbopack_context__.v({
  "description": "WidgetHeading-module-scss-module__scD-Gq__description",
  "fade-in": "WidgetHeading-module-scss-module__scD-Gq__fade-in",
  "header": "WidgetHeading-module-scss-module__scD-Gq__header",
  "info": "WidgetHeading-module-scss-module__scD-Gq__info",
  "no-transform": "WidgetHeading-module-scss-module__scD-Gq__no-transform",
  "rotate": "WidgetHeading-module-scss-module__scD-Gq__rotate",
});
